export const MONTHS = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun",
  "Jul", "Ago", "Set", "Oct", "Nov", "Dic",
] as const;

export type Role = "user" | "admin";
export type SubmissionStatus = "draft" | "closed";
export type ValidationStatus =
  | "not_required"
  | "not_submitted"
  | "pending_gmr"
  | "pending_line"
  | "observed_gmr"
  | "observed_line"
  | "accepted";

export interface Profile {
  id: string;
  fullName: string;
  email: string;
  role: Role;
}

export interface CostCenter {
  id: string;
  code: string;
  name: string;
}

export interface CycleMonth {
  month: number;
  enabled: boolean;
}

export interface Cycle {
  id: string;
  year: number;
  name: string;
  status: "draft" | "open" | "closed";
  officialVersionNumber: number | null;
  officializedAt: string | null;
  registrationEnabled: boolean;
  months: CycleMonth[];
  sourceFile: string;
  sourceImportedAt: string | null;
}

export interface SourceTaskVersion {
  versionNumber: number;
  sourceDocument: string;
  sourceDate: string | null;
  unit: string;
  values: number[];
}

export interface TaskRow {
  id: string;
  legacyKey: string;
  sourceVersions?: SourceTaskVersion[];
  activityCode: string;
  activityName: string;
  taskCode: string;
  taskName: string;
  unit: string;
  operationalDefinition?: string | null;
  criteria?: string | null;
  activityOperationalDefinition?: string | null;
  normativeBasis?: string | null;
  definitionResponsible?: string | null;
  definitionUpdatedOn?: string | null;
  baseline: number[];
  baselineVersionNumber: number;
  modified: Array<number | null>;
}

export interface VersionTaskSnapshot {
  taskId: string;
  values: number[];
  justification?: string;
}

export interface SubmissionVersion {
  id: string;
  versionNumber: number;
  justification: string;
  documentReference: string;
  createdByName: string;
  createdAt: string;
  targets: VersionTaskSnapshot[];
}

export interface WorkspaceData {
  profile: Profile;
  costCenters: CostCenter[];
  selectedCenterId: string;
  cycle: Cycle;
  submissionId: string | null;
  submissionStatus: SubmissionStatus;
  allowedMonths: number[] | null;
  tasks: TaskRow[];
  versions: SubmissionVersion[];
  taskJustifications: Record<string, string>;
  validationStatus: ValidationStatus;
  validationObservation: string | null;
}
